module.exports = __webpack_public_path__ + "assets/high.b29cf0d5.svg";